// Configul Cal.com embed — popup branded (forest/honey) peste site.
// Inițializarea se face o singură dată în App (initCalEmbed); CTA-urile primesc
// `calAttrs` ca să intercepteze click-ul și să deschidă booker-ul tematizat.
import { getCalApi } from '@calcom/embed-react'

export const CAL_NAMESPACE = '15min'
export const CAL_LINK = 'vorba.dev/15min'

// onClick oprește navigarea DOAR dacă Cal e gata (consimțit + inițializat) — atunci
// listener-ul Cal deschide popup-ul tematizat. Fără consimțământ, `__calReady` e false,
// deci nu prevenim default → CTA-ul navighează prin href la pagina de booking (tab nou),
// fără să încărcăm terțul Cal pe pagina noastră.
const calClick = (e) => {
  if (typeof window !== 'undefined' && window.__calReady) e.preventDefault()
}

// Atribute pentru orice CTA. `href` = fallback (fără JS / fără consimțământ).
export const calAttrs = {
  'data-cal-namespace': CAL_NAMESPACE,
  'data-cal-link': CAL_LINK,
  'data-cal-config': JSON.stringify({ layout: 'month_view', theme: 'dark' }),
  onClick: calClick,
}

// Variantă cu zi pre-selectată: deschide booker-ul direct pe data aleasă.
// Cal.com citește `month` (YYYY-MM) și `date` (YYYY-MM-DD) din query-ul link-ului,
// deci data trebuie pusă pe `data-cal-link` (NU pe href — onClick oprește navigarea).
export function calAttrsForDate(isoDate) {
  return {
    ...calAttrs,
    onClick: calClick,
    'data-cal-link': `${CAL_LINK}?month=${isoDate.slice(0, 7)}&date=${isoDate}`,
  }
}

// Tematizare: dark + brand honey (paleta vorba.dev). Apelat doar DUPĂ consimțământ.
// Setează window.__calReady ca CTA-urile să deschidă popup-ul în loc să navigheze.
export async function initCalEmbed() {
  const cal = await getCalApi({ namespace: CAL_NAMESPACE })
  cal('ui', {
    theme: 'dark',
    hideEventTypeDetails: false,
    layout: 'month_view',
    cssVarsPerTheme: {
      light: { 'cal-brand': '#E8A33D' },
      dark: { 'cal-brand': '#E8A33D' },
    },
  })
  if (typeof window !== 'undefined') window.__calReady = true
}
